import React from 'react';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

function Root() {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  )
}

export default Root